export const getTalksUrl = (locationId: string, agentID: string) => `
business/locations/${locationId}/agents/${agentID}/outbound_call`;
